import { Component, inject, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { UserService } from '../../_core/services/user.service';
import { ToastService } from '../../_core/services/toast.service';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-update-name',
  templateUrl: './update-name.component.html',
  styleUrls: ['./update-name.component.scss'],
  standalone: false
})
export class UpdateNameComponent implements OnInit {
  private modalController = inject(ModalController);
  firstName: string = "";
  lastName: string = "";
  constructor(private userService: UserService,
    private toastService: ToastService,
    private authService: AuthService) { }

  ngOnInit() {

  }

  submit() {
    this.trimSpaces();
    this.userService.updateMyProfile({ first_name: this.firstName, last_name: this.lastName })
      .subscribe({
        next: async (res) => {
          if (res?.data) {
            this.authService.updateAuthUser(res.data);
            this.modalController.dismiss();
          }
        },
        error: (responseError) => {
          if (responseError.message) {
            this.toastService.presentToast(responseError.message);
          } else {
            this.toastService.presentToast('Failed to update name');
          }
        }
      });
  }

  trimSpaces() {
    this.firstName = this.firstName.trim();
    this.lastName = this.lastName.trim();
  }

  // onEmailInput(event: any) {
  //   this.firstName = event.target.value;
  // }

  onFirstNameInput(event: any) {
    let value = event.target.value;
    const trimmed = value.replace(/^\s+/, '');
    this.firstName = trimmed;

    // Update the input's visual value
    if (trimmed !== value) {
      event.target.value = trimmed;
    }
  }

  onLastNameInput(event: any) {
    let value = event.target.value;
    const trimmed = value.replace(/^\s+/, '');
    this.lastName = trimmed;

    if (trimmed !== value) {
      event.target.value = trimmed;
    }
  }

  preventLeadingSpace(event: KeyboardEvent, currentValue: string) {
    if (!currentValue?.length && event.code === 'Space') {
      event.preventDefault();
    }
  }

  close() {
    this.modalController.dismiss();
  }

}
